/**
 * Composant modal réutilisable pour l'administration
 * @module admin/components/AdminModal
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Composant modal
 * @param {Object} props
 * @param {boolean} props.isOpen - Si true, le modal est ouvert
 * @param {function} props.onClose - Fonction appelée pour fermer le modal
 * @param {string} props.title - Titre du modal
 * @param {React.ReactNode} props.children - Contenu du modal
 * @param {React.ReactNode} [props.footer] - Contenu du footer (boutons, etc.)
 * @returns {JSX.Element|null}
 */
const AdminModal = ({ isOpen, onClose, title, children, footer }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="admin-modal-overlay" onClick={handleOverlayClick}>
      <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>{title}</h3>
          <button
            className="admin-modal-close"
            onClick={onClose}
            aria-label="Fermer"
          >
            ×
          </button>
        </div>
        <div className="admin-modal-body">{children}</div>
        {footer && <div className="admin-modal-footer">{footer}</div>}
      </div>
    </div>
  );
};

AdminModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
};

export default AdminModal;
